import { Grid, Stack, TextField } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { FormField, useFormStore } from '@tom-ui/utils'
import { FormProps } from '@yard/app/models/form-props.model'
import { observer } from 'mobx-react-lite'
import { ILimitStackHeightConfigAreaFormData } from '../../models/yard-setup.model'

interface Props extends FormProps {
  currentStackHeight?: number | null
  maxStackHeight?: number
  onSubmit: (formValues: ILimitStackHeightConfigAreaFormData) => Promise<void> | void
}

export const LimitStackHeightConfigAreaForm = observer((props: Props) => {
  const { id, currentStackHeight, maxStackHeight, onSubmit } = props
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  const formStore = useFormStore<ILimitStackHeightConfigAreaFormData>()

  const handleSubmit = () => {
    if (formStore.validate()) {
      onSubmit(formStore.data)
    }
  }

  return (
    <Grid
      id={id}
      component='form'
      autoComplete='off'
      noValidate
      container
      onSubmit={event => {
        event.preventDefault()
        handleSubmit()
      }}
      spacing={theme.customSpacing.m}
    >
      <Grid size={12}>
        <FormField
          formStore={formStore}
          name={'stackHeight'}
          initialValue={currentStackHeight ?? ''}
          validate={value => {
            if (!value) return t('fieldIsRequired', 'Field is required')

            if (maxStackHeight !== undefined && Number(value) > Number(maxStackHeight))
              return t(
                'stackHeightExceedsMax',
                'Stack height exceeds the maximum allowed height of {maxHeight}',
                { maxHeight: maxStackHeight },
              )
          }}
        >
          {store => (
            <Stack>
              <TextField
                {...store.props}
                autoFocus
                fullWidth
                label={`${t('maxStackHeight', 'Max stack height')}`}
                required
                name='stackHeight'
                type='number'
                error={!!store.error}
                helperText={store.error}
              />
            </Stack>
          )}
        </FormField>
      </Grid>
    </Grid>
  )
})
